import './style.scss';
import { SaleBadgeProps } from '../../types';
import { generateSalePercentageBasedOnType } from 'utils';

export const BagelcodeSaleBadge = ({
  salePercentage,
  salePercentageDisplayType,
}: SaleBadgeProps) => {
  return (
    <div className={'bagelcode__sale-badge'}>
      <span className={'bagelcode__sale-badge__number'}>
        {generateSalePercentageBasedOnType(
          salePercentage,
          salePercentageDisplayType,
        )}
      </span>
      <span className={'bagelcode__sale-badge__text'}>SALE</span>
    </div>
  );
};
